import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

import isMobile from "../../../helpers/isMobile";

const Skeleton = styled(MUISkeleton)``;

const Row = styled((props) => (
	<div className={props.className}>
		<Skeleton
			variant="rounded"
			height={30}
			width="100%"
			sx={{ maxWidth: "30px" }}
		/>
		{[...Array(props.columns).keys()].map((value) => (
			<Skeleton key={value} variant="text" height={50} width="100%" />
		))}
		<Skeleton
			variant="rounded"
			height={30}
			width="100%"
			sx={{ maxWidth: "30px" }}
		/>
	</div>
))`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Header = styled((props) => (
	<div className={props.className}>
		<Skeleton
			variant="rounded"
			height={30}
			width="100%"
			sx={{ maxWidth: "30px", visibility: "hidden" }}
		/>
		{[...Array(props.columns).keys()].map((value) => (
			<Skeleton key={value} variant="text" height={50} width="100%" />
		))}
		<Skeleton
			variant="rounded"
			height={30}
			width="100%"
			sx={{ maxWidth: "30px", visibility: "hidden" }}
		/>
	</div>
))`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Footer = styled((props) => (
	<div className={props.className}>
		<Skeleton variant="rounded" height={30} width="25%" />
	</div>
))`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MobileHeader = styled((props) => (
	<div className={props.className}>
		<Skeleton variant="rounded" height={20} width="40%" />
	</div>
))`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

function ExamsList(props) {
	const renderRows = () => {
		return [...Array(props.rows).keys()].map((value) => (
			<Row key={value} columns={props.columns} />
		));
	};

	const renderContent = () => {
		if (isMobile()) {
			return (
				<>
					<MobileHeader />
					{[...Array(props.rows).keys()].map((value) => (
						<Skeleton key={value} variant="rounded" height={80} width="100%" />
					))}
				</>
			);
		}

		return (
			<>
				<Header columns={props.columns} />
				{renderRows()}
				<Footer />
			</>
		);
	};

	return <div className={props.className}>{renderContent()}</div>;
}

export default styled(ExamsList)`
  padding: 0 12px 12px;

  ${mq(Breakpoints.sm)} {
    margin-top: 16px;
    padding: 0;

    ${Skeleton} {
      margin: 8px 0;
    }
  }
`;
